import { Button, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import EasyCareTerms from '../GroupedAddonContent/easy-care-terms';
import TermsAndConditions from '../TermsAndConditions';
import { getTermsAndConditions } from '../../utils/getTermsAndConditions';
import { ADDON_PRODUCT_KIND } from '../../../../constants';

type TermsAndSubscribeButtonProps = {
  kind: string;
  isSubmitDisabled?: boolean;
  submitButtonLabel: string;
  handleClick: () => void;
  displayTC?: boolean;
  isLastStep?: boolean;
};

const TermsAndSubscribeButton = ({
  kind,
  handleClick,
  isSubmitDisabled,
  submitButtonLabel,
  displayTC = true,
  isLastStep,
}: TermsAndSubscribeButtonProps) => {
  const { t } = useTranslation('ShopAddons');

  const termsAndConditionsContent = t(`termsAndConditions.${getTermsAndConditions(kind)}`);
  return (
    <>
      {kind === ADDON_PRODUCT_KIND.easyCare
        ? isLastStep && <EasyCareTerms />
        : displayTC && <TermsAndConditions content={termsAndConditionsContent} />}
      <Button width="100%" onClick={handleClick} disabled={isSubmitDisabled}>
        {submitButtonLabel}
      </Button>
      <Txt component="p" variant="tinyRegular" color="subtle">
        {t('cart.taxesDisclaimer')}
      </Txt>
    </>
  );
};

export default TermsAndSubscribeButton;
